import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = { style: {"width":"100%","height":"100%"} }
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "col-12 input-group-sm float-start" }
const _hoisted_4 = { class: "col-12 input-group-sm float-start" }
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("small", null, "クエリに時間を利用する", -1)
const _hoisted_7 = {
  style: {"text-align":"left"},
  class: "col-4 offset-4"
}
const _hoisted_8 = { class: "col-12 input-group-sm float-start" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-6 float-start" }
const _hoisted_12 = { style: {"display":"inline-block"} }
const _hoisted_13 = { style: {"display":"inline-block"} }
const _hoisted_14 = { style: {"display":"inline-block"} }
const _hoisted_15 = { style: {"display":"inline-block"} }
const _hoisted_16 = { class: "col-6 float-end" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_18 = {
  key: 0,
  class: "card tab-contents col-12",
  style: {"margin-bottom":"1%","padding":"2%","padding-left":"4%","padding-right":"4%","display":"inline-block"}
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { key: 2 }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { key: 3 }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { key: 4 }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = {
  key: 5,
  class: "col-12",
  style: {"height":"50vh","padding-bottom":"7vh","display":"inline-block"}
}
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { key: 6 }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = { key: 7 }
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  class: "card",
  style: {"cursor":"pointer","padding":"1%","display":"inline-block"}
}
const _hoisted_42 = ["draggable", "onDrop", "onMouseover"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = { key: 1 }
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = { key: 2 }
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = { key: 3 }
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = { key: 4 }
const _hoisted_53 = ["innerHTML"]
const _hoisted_54 = {
  key: 5,
  class: "col-12",
  style: {"height":"50vh","padding-bottom":"7vh","display":"inline-block"}
}
const _hoisted_55 = ["innerHTML"]
const _hoisted_56 = { key: 6 }
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = { key: 7 }
const _hoisted_59 = ["innerHTML"]
const _hoisted_60 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_61 = { class: "col-12 row" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("h5", { class: "col-12" }, " 検索設定 ", -1)
const _hoisted_63 = {
  style: {"text-align":"center"},
  class: "col-12"
}
const _hoisted_64 = ["onUpdate:modelValue"]
const _hoisted_65 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_66 = { class: "col-12" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("h5", null, " センサのIDの選択 ", -1)
const _hoisted_68 = {
  style: {"text-align":"left"},
  class: "col-4 offset-4"
}
const _hoisted_69 = ["onUpdate:modelValue"]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("small", null, "集計データのテーブルを取得する ", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_72 = ["onUpdate:modelValue"]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("small", null, "間隔内の最初のデータのテーブルを取得する ", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_75 = ["onUpdate:modelValue"]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("small", null, "未加工のデータのテーブル取得する ", -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_78 = ["onUpdate:modelValue"]
const _hoisted_79 = /*#__PURE__*/_createElementVNode("small", null, "最後に到達したデータのテーブル取得する ", -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_81 = ["onUpdate:modelValue"]
const _hoisted_82 = /*#__PURE__*/_createElementVNode("small", null, "纏めてリクエストする。*データはキャッシュされません。 ", -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_84 = ["id"]
const _hoisted_85 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_86 = { class: "col-12 row" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("h5", { class: "col-12" }, " タブを開いた時に取得するデータのカスタム設定 ", -1)
const _hoisted_88 = { class: "col-6" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("b", null, "テーブル ( コンマで複数指定可能 例: agg=10min,agg=1hour )", -1)
const _hoisted_90 = ["onUpdate:modelValue"]
const _hoisted_91 = { class: "col-6" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("b", null, "期間 ( 日数 )", -1)
const _hoisted_93 = ["onUpdate:modelValue"]
const _hoisted_94 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_95 = { class: "col-12" }
const _hoisted_96 = {
  class: "card col-12",
  style: {"padding":"1%","display":"inline-block"}
}
const _hoisted_97 = /*#__PURE__*/_createElementVNode("b", { style: {"text-align":"left","width":"100%","display":"inline-block"} }, "グラフ", -1)
const _hoisted_98 = ["value"]
const _hoisted_99 = { style: {"text-align":"left","width":"100%","display":"inline-block"} }
const _hoisted_100 = { style: {"text-align":"left","width":"100%","display":"inline-block"} }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("b", { style: {"text-align":"left","width":"100%","display":"inline-block"} }, "タイトル", -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("b", { style: {"text-align":"left","width":"100%","display":"inline-block"} }, "表示位置", -1)
const _hoisted_104 = { id: "app" }
const _hoisted_105 = {
  style: {"display":"inline-block"},
  class: "col-3"
}
const _hoisted_106 = /*#__PURE__*/_createElementVNode("label", null, "タブより上", -1)
const _hoisted_107 = {
  style: {"display":"inline-block"},
  class: "col-3"
}
const _hoisted_108 = /*#__PURE__*/_createElementVNode("label", null, "タブより下", -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_110 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_111 = ["src"]
const _hoisted_112 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"10%"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateSelector = _resolveComponent("DateSelector")!
  const _component_Metric = _resolveComponent("Metric")!
  const _component_CustomDateSelector = _resolveComponent("CustomDateSelector")!
  const _component_JSField = _resolveComponent("JSField")!
  const _component_PlateauView = _resolveComponent("PlateauView")!
  const _component_Map = _resolveComponent("Map")!
  const _component_Image = _resolveComponent("Image")!
  const _component_ImageV4 = _resolveComponent("ImageV4")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("link", {
      rel: "stylesheet",
      href: _ctx.css
    }, null, 8, _hoisted_2),
    _withDirectives(_createElementVNode("h2", null, _toDisplayString(_ctx.setting.title), 513), [
      [_vShow, !_ctx.showEditMode]
    ]),
    _withDirectives(_createElementVNode("h2", null, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.setting.title) = $event))
      }, null, 512), [
        [_vModelText, _ctx.setting.title]
      ])
    ], 512), [
      [_vShow, _ctx.showEditMode]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createVNode(_component_DateSelector, {
        ref: "dateselector",
        sensorIDs: _ctx.sensorIDs,
        showGranularitySelector: _ctx.showGranularitySelector,
        useTimeForQueries: _ctx.setting.tabs ?  _ctx.setting.tabs[_ctx.currentTabNum]?.useTimeForQueries:false
      }, null, 8, ["sensorIDs", "showGranularitySelector", "useTimeForQueries"])
    ], 512), [
      [_vShow, _ctx.showDateSelector]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setting.tabs, (tab, i) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: tab.name,
          style: {"text-align":"left"},
          class: "col-4 offset-4"
        }, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control-input",
            "onUpdate:modelValue": ($event: any) => ((tab.useTimeForQueries) = $event),
            type: "checkbox"
          }, null, 8, _hoisted_5), [
            [_vModelCheckbox, tab.useTimeForQueries]
          ]),
          _createTextVNode(),
          _hoisted_6
        ], 512)), [
          [_vShow, _ctx.showEditMode&&(_ctx.currentTabNum===i)]
        ])
      }), 128)),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showDateSelector) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.showDateSelector]
        ]),
        _withDirectives(_createElementVNode("small", null, "データ検索を非表示にする", 512), [
          [_vShow, _ctx.showDateSelector]
        ]),
        _withDirectives(_createElementVNode("small", null, "データ検索を表示する ", 512), [
          [_vShow, !_ctx.showDateSelector]
        ])
      ])
    ], 512), [
      [_vShow, _ctx.showEditMode]
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", _hoisted_12, [
              _withDirectives(_createElementVNode("span", {
                class: "card",
                style: {"padding":"10px","cursor":"pointer"},
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onEditMode(true)))
              }, "編集 ", 512), [
                [_vShow, _ctx.useEditMode && !_ctx.showEditMode]
              ])
            ]),
            _createElementVNode("li", _hoisted_13, [
              _withDirectives(_createElementVNode("span", {
                class: "card",
                style: {"padding":"10px","cursor":"pointer"},
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onEditCSS()))
              }, "CSSの編集", 512), [
                [_vShow, _ctx.useEditMode && !_ctx.showEditMode]
              ])
            ]),
            _createElementVNode("li", _hoisted_14, [
              _withDirectives(_createElementVNode("span", {
                class: "card",
                style: {"padding":"10px","cursor":"pointer"},
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onEditMode(false)))
              }, "編集を止める ", 512), [
                [_vShow, _ctx.useEditMode && _ctx.showEditMode]
              ])
            ]),
            _createElementVNode("li", _hoisted_15, [
              _withDirectives(_createElementVNode("span", {
                class: "card",
                style: {"padding":"10px","cursor":"pointer"},
                onClick: _cache[5] || (_cache[5] = ($event: any) => ((_ctx.saveViews( { isSafeSaveData :true}))))
              }, "保存 ", 512), [
                [_vShow, _ctx.useEditMode && _ctx.showEditMode]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            class: "btn btn-dark",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onUpdate()))
          }, "更新")
        ])
      ])
    ]),
    _hoisted_17,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, j) => {
      return _withDirectives((_openBlock(), _createElementBlock("article", {
        key: j,
        class: "col-12"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab, (view, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: view }, [
            (view.position=="top")
              ? (_openBlock(), _createElementBlock("section", _hoisted_18, [
                  _withDirectives(_createElementVNode("b", {
                    onClick: ($event: any) => (_ctx.deleteView( _ctx.currentTabNum,i )),
                    class: "card",
                    style: {"margin":"2%","cursor":"pointer"}
                  }, " x ", 8, _hoisted_19), [
                    [_vShow, _ctx.useEditMode && _ctx.showEditMode]
                  ]),
                  (view.type==='iframe' && _ctx.currentTabNum==j )
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "col-12",
                        innerHTML: view.html
                      }, null, 8, _hoisted_20))
                    : _createCommentVNode("", true),
                  (view.type==='metric')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_21, [
                        _createElementVNode("div", {
                          innerHTML: view.title
                        }, null, 8, _hoisted_22),
                        _createVNode(_component_Metric, {
                          path: view.src,
                          ref_for: true,
                          ref: "metric",
                          Sql: _ctx.Sql
                        }, null, 8, ["path", "Sql"])
                      ]))
                    : _createCommentVNode("", true),
                  (view.type==='customdateselector')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_23, [
                        _createElementVNode("div", {
                          innerHTML: view.title
                        }, null, 8, _hoisted_24),
                        _createVNode(_component_CustomDateSelector, {
                          path: view.src,
                          ref_for: true,
                          ref: el => _ctx.addRef(el,view,'customdateselector', j,i),
                          Sql: _ctx.Sql,
                          onSave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.saveViews({ isSafeSaveData :false})))
                        }, null, 8, ["path", "Sql"])
                      ]))
                    : _createCommentVNode("", true),
                  (view.type==='jsfield')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_25, [
                        _createElementVNode("div", {
                          innerHTML: view.title
                        }, null, 8, _hoisted_26),
                        _createVNode(_component_JSField, {
                          path: view.src,
                          ref_for: true,
                          ref: "jsfield",
                          allowList: _ctx.allowList,
                          Sql: _ctx.Sql
                        }, null, 8, ["path", "allowList", "Sql"])
                      ]))
                    : _createCommentVNode("", true),
                  (view.type==='plateauview')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_27, [
                        _createElementVNode("div", {
                          innerHTML: view.title
                        }, null, 8, _hoisted_28),
                        _createVNode(_component_PlateauView, {
                          path: view.src,
                          ref_for: true,
                          ref: "plateauview"
                        }, null, 8, ["path"])
                      ]))
                    : _createCommentVNode("", true),
                  (view.type==='map')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_29, [
                        _createElementVNode("div", {
                          innerHTML: view.title
                        }, null, 8, _hoisted_30),
                        _createVNode(_component_Map, {
                          path: view.src,
                          ref_for: true,
                          ref: "map",
                          Sql: _ctx.Sql
                        }, null, 8, ["path", "Sql"])
                      ]))
                    : _createCommentVNode("", true),
                  (view.type==='image')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_31, [
                        _createElementVNode("div", {
                          innerHTML: view.title
                        }, null, 8, _hoisted_32),
                        _createTextVNode(" " + _toDisplayString(view.image) + " ", 1),
                        _createVNode(_component_Image, {
                          path: view.src
                        }, null, 8, ["path"])
                      ]))
                    : _createCommentVNode("", true),
                  (view.type==='imagev4')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_33, [
                        _createElementVNode("div", {
                          innerHTML: view.title
                        }, null, 8, _hoisted_34),
                        _createTextVNode(" " + _toDisplayString(view.image) + " ", 1),
                        _createVNode(_component_ImageV4, {
                          onShowLoader: _ctx.showLoader,
                          path: view.src
                        }, null, 8, ["onShowLoader", "path"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        _hoisted_35
      ])), [
        [_vShow, _ctx.currentTabNum==j]
      ])
    }), 128)),
    _hoisted_36,
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setting.tabs, (tab, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: tab.name
        }, [
          _createElementVNode("li", {
            class: "card",
            style: {"cursor":"pointer","padding":"1%","display":"inline-block"},
            onClick: ($event: any) => (_ctx.changeTab(i))
          }, [
            (_ctx.currentTabNum===i)
              ? (_openBlock(), _createElementBlock("b", _hoisted_38, _toDisplayString(tab.name), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(tab.name), 1)),
            _withDirectives(_createElementVNode("b", {
              style: {"cursor":"pointer"},
              onClick: ($event: any) => (_ctx.deleteTab( i ))
            }, " x ", 8, _hoisted_40), [
              [_vShow, _ctx.showEditMode]
            ])
          ], 8, _hoisted_37),
          _withDirectives(_createElementVNode("li", _hoisted_41, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              style: {"display":"inline-block","width":"120px"},
              type: "text",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.addingTabName) = $event))
            }, null, 512), [
              [_vModelText, _ctx.addingTabName]
            ]),
            _createTextVNode(),
            _createElementVNode("b", {
              style: {"cursor":"pointer"},
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.addTab && _ctx.addTab(...args)))
            }, " + ")
          ], 512), [
            [_vShow, _ctx.showEditMode]
          ])
        ], 64))
      }), 128))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, j) => {
      return _withDirectives((_openBlock(), _createElementBlock("article", {
        key: j,
        class: "col-12"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab, (view, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: view }, [
            (view.position=="bottom")
              ? (_openBlock(), _createElementBlock("section", {
                  key: 0,
                  draggable: _ctx.showEditMode,
                  onDragover: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"])),
                  onDrop: ($event: any) => (_ctx.endCardDrag(i,tab)),
                  onMouseover: ($event: any) => (_ctx.startCardDrag(i)),
                  class: _normalizeClass([{ draggable: _ctx.showEditMode }, "card tab-contents col-12"]),
                  style: {"margin-bottom":"1%","padding":"1%","padding-left":"4%","padding-right":"4%","display":"inline-block"}
                }, [
                  _withDirectives(_createElementVNode("b", {
                    onClick: ($event: any) => (_ctx.deleteView( _ctx.currentTabNum,i )),
                    class: "card",
                    style: {"margin":"2%","cursor":"pointer"}
                  }, " x ", 8, _hoisted_43), [
                    [_vShow, _ctx.useEditMode && _ctx.showEditMode]
                  ]),
                  _withDirectives(_createElementVNode("b", {
                    onClick: ($event: any) => (_ctx.copyEdit( _ctx.currentTabNum,i )),
                    class: "card",
                    style: {"margin":"2%","cursor":"pointer"}
                  }, " Copy ", 8, _hoisted_44), [
                    [_vShow, _ctx.useEditMode && _ctx.showEditMode]
                  ]),
                  (view.type==='iframe' && _ctx.currentTabNum==j )
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "col-12",
                        innerHTML: view.html
                      }, null, 8, _hoisted_45))
                    : _createCommentVNode("", true),
                  (view.type==='metric')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_46, [
                        _createElementVNode("div", {
                          innerHTML: view.title
                        }, null, 8, _hoisted_47),
                        _createVNode(_component_Metric, {
                          path: view.src,
                          ref_for: true,
                          ref: "metric",
                          Sql: _ctx.Sql
                        }, null, 8, ["path", "Sql"])
                      ]))
                    : _createCommentVNode("", true),
                  (view.type==='customdateselector')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_48, [
                        _createElementVNode("div", {
                          innerHTML: view.title
                        }, null, 8, _hoisted_49),
                        _createVNode(_component_CustomDateSelector, {
                          path: view.src,
                          ref_for: true,
                          ref: "customdateselector",
                          Sql: _ctx.Sql,
                          onSave: _cache[10] || (_cache[10] = ($event: any) => (_ctx.saveViews({ isSafeSaveData :false})))
                        }, null, 8, ["path", "Sql"])
                      ]))
                    : _createCommentVNode("", true),
                  (view.type==='jsfield')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_50, [
                        _createElementVNode("div", {
                          innerHTML: view.title
                        }, null, 8, _hoisted_51),
                        _createVNode(_component_JSField, {
                          path: view.src,
                          ref_for: true,
                          ref: "jsfield",
                          allowList: _ctx.allowList,
                          Sql: _ctx.Sql
                        }, null, 8, ["path", "allowList", "Sql"])
                      ]))
                    : _createCommentVNode("", true),
                  (view.type==='plaeauview')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_52, [
                        _createElementVNode("div", {
                          innerHTML: view.title
                        }, null, 8, _hoisted_53),
                        _createVNode(_component_PlateauView, {
                          path: view.src,
                          ref_for: true,
                          ref: "plateauview"
                        }, null, 8, ["path"])
                      ]))
                    : _createCommentVNode("", true),
                  (view.type==='map')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_54, [
                        _createElementVNode("div", {
                          innerHTML: view.title
                        }, null, 8, _hoisted_55),
                        _createVNode(_component_Map, {
                          path: view.src,
                          ref_for: true,
                          ref: "map",
                          Sql: _ctx.Sql
                        }, null, 8, ["path", "Sql"])
                      ]))
                    : _createCommentVNode("", true),
                  (view.type==='image')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_56, [
                        _createElementVNode("div", {
                          innerHTML: view.title
                        }, null, 8, _hoisted_57),
                        _createTextVNode(" " + _toDisplayString(view.image) + " ", 1),
                        _createVNode(_component_Image, {
                          path: view.src
                        }, null, 8, ["path"])
                      ]))
                    : _createCommentVNode("", true),
                  (view.type==='imagev4')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_58, [
                        _createElementVNode("div", {
                          innerHTML: view.title
                        }, null, 8, _hoisted_59),
                        _createTextVNode(" " + _toDisplayString(view.image) + " ", 1),
                        _createVNode(_component_ImageV4, {
                          path: view.src
                        }, null, 8, ["path"])
                      ]))
                    : _createCommentVNode("", true)
                ], 42, _hoisted_42))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        _hoisted_60
      ])), [
        [_vShow, _ctx.currentTabNum==j]
      ])
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setting.tabs, (tab, i) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        key: tab.name,
        class: "col-12"
      }, [
        _createElementVNode("div", _hoisted_61, [
          _hoisted_62,
          _createElementVNode("div", _hoisted_63, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control-input",
              "onUpdate:modelValue": ($event: any) => ((tab.useTimeForQueries) = $event),
              type: "checkbox"
            }, null, 8, _hoisted_64), [
              [_vModelCheckbox, tab.useTimeForQueries]
            ]),
            _createTextVNode(" クエリに時間を利用する ")
          ])
        ]),
        _hoisted_65,
        _createElementVNode("div", _hoisted_66, [
          _hoisted_67,
          _createElementVNode("div", _hoisted_68, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control-input",
              "onUpdate:modelValue": ($event: any) => ((tab.needAggregateData) = $event),
              type: "checkbox"
            }, null, 8, _hoisted_69), [
              [_vModelCheckbox, tab.needAggregateData]
            ]),
            _hoisted_70,
            _hoisted_71,
            _withDirectives(_createElementVNode("input", {
              class: "form-control-input",
              "onUpdate:modelValue": ($event: any) => ((tab.needFirstData) = $event),
              type: "checkbox"
            }, null, 8, _hoisted_72), [
              [_vModelCheckbox, tab.needFirstData]
            ]),
            _hoisted_73,
            _hoisted_74,
            _withDirectives(_createElementVNode("input", {
              class: "form-control-input",
              "onUpdate:modelValue": ($event: any) => ((tab.needRawData) = $event),
              type: "checkbox"
            }, null, 8, _hoisted_75), [
              [_vModelCheckbox, tab.needRawData]
            ]),
            _hoisted_76,
            _hoisted_77,
            _withDirectives(_createElementVNode("input", {
              class: "form-control-input",
              "onUpdate:modelValue": ($event: any) => ((tab.needLatestData) = $event),
              type: "checkbox"
            }, null, 8, _hoisted_78), [
              [_vModelCheckbox, tab.needLatestData]
            ]),
            _hoisted_79,
            _hoisted_80,
            _withDirectives(_createElementVNode("input", {
              class: "form-control-input",
              "onUpdate:modelValue": ($event: any) => ((tab.RequestAllAtOnce) = $event),
              type: "checkbox"
            }, null, 8, _hoisted_81), [
              [_vModelCheckbox, tab.RequestAllAtOnce]
            ]),
            _hoisted_82
          ]),
          _hoisted_83,
          _createElementVNode("input", {
            ref_for: true,
            ref: "pkeys",
            id: 'pkeys-'+tab.name+'-'+i,
            type: "text"
          }, null, 8, _hoisted_84),
          _hoisted_85
        ]),
        _createElementVNode("div", _hoisted_86, [
          _hoisted_87,
          _createElementVNode("div", _hoisted_88, [
            _hoisted_89,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              "onUpdate:modelValue": ($event: any) => ((tab.defaultTables) = $event),
              type: "text"
            }, null, 8, _hoisted_90), [
              [_vModelText, tab.defaultTables]
            ])
          ]),
          _createElementVNode("div", _hoisted_91, [
            _hoisted_92,
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              "onUpdate:modelValue": ($event: any) => ((tab.defaultRangOfDate) = $event),
              type: "number"
            }, null, 8, _hoisted_93), [
              [_vModelText, tab.defaultRangOfDate]
            ])
          ])
        ]),
        _hoisted_94
      ], 512)), [
        [_vShow, _ctx.showEditMode&&(_ctx.currentTabNum===i)]
      ])
    }), 128)),
    _withDirectives(_createElementVNode("article", _hoisted_95, [
      _createElementVNode("section", _hoisted_96, [
        _hoisted_97,
        _withDirectives(_createElementVNode("select", {
          class: "form-control",
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedEditTamplateName) = $event)),
          onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changeSelectedEditView($event)))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewTemplates, (option, i) => {
            return (_openBlock(), _createElementBlock("option", {
              key: i,
              value: option.template_name
            }, _toDisplayString(option.template_name), 9, _hoisted_98))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.selectedEditTamplateName]
        ]),
        _withDirectives(_createElementVNode("b", _hoisted_99, "SRC", 512), [
          [_vShow, _ctx.selectedEditView.template_type=='iframe']
        ]),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedEditView.src) = $event)),
          type: "text"
        }, null, 512), [
          [_vShow, _ctx.selectedEditView.template_type=='iframe'],
          [_vModelText, _ctx.selectedEditView.src]
        ]),
        _withDirectives(_createElementVNode("b", _hoisted_100, "パラメータ", 512), [
          [_vShow, _ctx.selectedEditView.template_type=='image'||_ctx.selectedEditView.template_type=='imagev4']
        ]),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.editViewQuery) = $event)),
          type: "text"
        }, null, 512), [
          [_vShow, _ctx.selectedEditView.template_type=='image'||_ctx.selectedEditView.template_type=='imagev4'],
          [_vModelText, _ctx.editViewQuery]
        ]),
        _hoisted_101,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          type: "text",
          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.editingViewTitle) = $event))
        }, null, 512), [
          [_vModelText, _ctx.editingViewTitle]
        ]),
        _hoisted_102,
        _hoisted_103,
        _createElementVNode("div", _hoisted_104, [
          _createElementVNode("div", _hoisted_105, [
            _hoisted_106,
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              class: "col-2",
              value: "top",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.editingViewPosition) = $event))
            }, null, 512), [
              [_vModelRadio, _ctx.editingViewPosition]
            ])
          ]),
          _createElementVNode("div", _hoisted_107, [
            _hoisted_108,
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              class: "col-2",
              value: "bottom",
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.editingViewPosition) = $event))
            }, null, 512), [
              [_vModelRadio, _ctx.editingViewPosition]
            ])
          ])
        ]),
        _hoisted_109,
        _createElementVNode("span", {
          class: "card",
          style: {"cursor":"pointer","padding":"1%","display":"inline-block"},
          onClick: _cache[19] || (_cache[19] = ($event: any) => ( _ctx.editViewURL = _ctx.replacePathParam(_ctx.addEditViewQuery(  _ctx.selectedEditView.src  ) )))
        }, " 表示 "),
        _hoisted_110,
        _createElementVNode("iframe", {
          scrolling: "yes",
          id: "edit-iframe",
          style: {"width":"100%","display":"inline-block","height":"600px","overflow-y":"scroll"},
          src: _ctx.editViewURL
        }, null, 8, _hoisted_111),
        _hoisted_112,
        _createElementVNode("span", {
          class: "card",
          style: {"cursor":"pointer","padding":"1%","display":"inline-block"},
          onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.addView && _ctx.addView(...args)))
        }, " 追加 ")
      ])
    ], 512), [
      [_vShow, _ctx.showEditMode]
    ]),
    _hoisted_113
  ]))
}